const CONFIGURATION = {
  APP_INSIGHTS_CONNECTION_STRING:
    "InstrumentationKey=1662b63d-3d41-4bc6-a33d-a0dedf3de9a3;IngestionEndpoint=https://canadacentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://canadacentral.livediagnostics.monitor.azure.com/",
  TABIT_DIRECT_URL: "https://tabit-direct-qa.azurewebsites.net/",
  TABIT_STORAGE_URL: "https://tabituilibrary.blob.core.windows.net",
};

export default CONFIGURATION;
